
/* injects from baggage-loader */

'use strict';

import uiRouter from '@uirouter/angularjs';

import config from './index.config';
import run from './index.run';
import indexComponents from './index.components';
import indexRoutes from './index.routes';

import assignmentRoutes from './auth/components/assignment/assignment.routes';
import authenticationRoutes from './public/authentication/authentication.routes';
import campaignRoutes from './auth/management/campaign/campaign.routes';
import confirmedRoutes from './auth/components/confirmed/confirmed.routes';
import coreModule from './core/core.module';
import fileManagementRoutes from './auth/management/fileManagement/fileManagement.routes';
import lockRoutes from './auth/components/lock/lock.routes';
import notFoundRoutes from './core/components/notFound/notFound.routes';
import pendingToConfirmCompany from './auth/components/pendingToConfirmCompany/pendingToConfirmCompany.routes';
import pendingToConfirmOffice from './auth/components/pendingToConfirmOffice/pendingToConfirmOffice.routes';
import pendingToConfirmRoutes from './auth/components/pendingToConfirm/pendingToConfirm.routes';
import userManagement from './auth/management/user/user.routes';
import unlockRoutes from './auth/components/unlock/unlock.routes';
import returnComponentRoute from './auth/components/returnComponent/returnComponent.route';
import returnToCompanyRoute from './auth/components/returnToCompany/returnToCompany.route';
import reportRoutes from './auth/management/report/report.routes';

/**
 * Main module definition.
 */
const App = angular.module("raspagana", [
	/**
	 * Plugins.
	 */
	uiRouter,
	'satellizer',
	"ngAnimate",
	"ngCookies",
	"ngTouch",
	"ngSanitize",
	"ngMessages",
	"ngResource",
	'oitozero.ngSweetAlert',
	"oc.lazyLoad",
	'ngMaterial',
	'md.data.table',
	'ngFileSaver',
	/**
	 * Core.
	 */
	coreModule.name,
	/**
	 * Components
	 */
	indexComponents.name,
	/**
	 * Routes
	 */
	authenticationRoutes.name,
	assignmentRoutes.name,
	campaignRoutes.name,
	confirmedRoutes.name,
	fileManagementRoutes.name,
	indexRoutes.name,
	lockRoutes.name,
	notFoundRoutes.name,
	pendingToConfirmCompany.name,
	pendingToConfirmOffice.name,
	pendingToConfirmRoutes.name,
	returnComponentRoute.name,
	returnToCompanyRoute.name,
	reportRoutes.name,
	unlockRoutes.name,
	userManagement.name
]);

App
	.config(config)
	.run(run);

export default App;



// WEBPACK FOOTER //
// ./src/app/index.module.js